module.exports = __webpack_public_path__ + "img/info-circle-fill.74962b48.svg";